import React, { useState, useEffect } from "react";
import { MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import apiManager from "../../../../../lib/apiManager/apiManager";
import { sortByStatus, getTableTheme, defaultSort } from "../../../../../lib/functions/tableFunctions";
import { Link } from "react-router-dom";
import helpCenterTopicDataManipulation from "../../../../../lib/dataManipulation/helpCenter/topics/helpCenterTopicDataManipulation";
import { useResetPageState } from "../../../../../lib/functions/customHooks";

const EditHelpCenterTopicListPage = () => {
  useResetPageState();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const columns = [
    "Category",
    "Subcategory",
    "Title",
    "Featured",
    {
      name: "Status",
      options: {
        customBodyRender: value => getStatusJSX(value),
      },
    },
    "Order",
    {
      name: "Edit",
      options: {
        customBodyRender: value => (
          <Link to={"/edit/help-center-topic/" + value} className="btn btn-default fa fa-edit" />
        ),
      },
    },
  ];

  const datatableOptions = {
    selectableRows: "none",
    print: false,
    download: false,
    filter: false,
    viewColumns: false,
    responsive: "stacked",
    customSort: (data, colIndex, order) => {
      if (colIndex === 4) {
        return sortByStatus(data, colIndex, order);
      } else {
        return defaultSort(data, colIndex, order);
      }
    },
  };

  useEffect(() => {
    setHelpCenterListData(setData, setLoading);
  }, []);

  return (
    <React.Fragment>
      <section className="content-header">
        <h1>Edit help center topics</h1>
      </section>
      <section className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="timetable">
              <MuiThemeProvider theme={getTableTheme()}>
                <MUIDataTable
                  className={loading ? "loading" : ""}
                  title={"Help topics"}
                  data={data}
                  columns={columns}
                  options={datatableOptions}
                />
              </MuiThemeProvider>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

const getStatusJSX = status => {
  let parsedStatus = "";

  switch (status) {
    case "finished":
      parsedStatus = (
        <React.Fragment>
          <i className="fa fa-fw fa-circle green" />
          Finished
        </React.Fragment>
      );
      break;
    case "draft":
      parsedStatus = (
        <React.Fragment>
          <i className="fa fa-fw fa-circle grey" />
          Draft
        </React.Fragment>
      );
      break;
    case "inactive":
      parsedStatus = (
        <React.Fragment>
          <i className="fa fa-fw fa-circle red" />
          Inactive
        </React.Fragment>
      );
      break;
    default:
      break;
  }

  return parsedStatus;
};

const setHelpCenterListData = async (setData, setLoading) => {
  const data = await apiManager.getEntityList("helpCenterTopic");
  const topics = data && data.helpCenterTopics ? data.helpCenterTopics : [];
  const categories = data && data.categories ? data.categories : [];

  setData(helpCenterTopicDataManipulation.inwardDatatable(topics, categories));
  setLoading(false);

  return [];
};

export default EditHelpCenterTopicListPage;
